import { config } from '@/config';

export const powerbiUrlLink = config.powerbiUrl.link;
export const regexReportLink =
  /^https:\/\/app\.powerbi\.com\/groups\/([\w+].*)\/reports\/([\w+].*)?/;
